import { createRequest } from "@/common/helpers/RequestHelpers";
import pDebounce from "p-debounce";
import { NotificationManager } from "react-notifications";
import { Actions as ALLOWANCEACTIONS } from "./allowanceActions";
import { Actions as WORK_LOCATION_ACTIONS } from "./workLocationActions";
import apiURL from "./apiURL";
import { Actions as EMPLOYEE_ACTIONS } from "./employeeActions";
import { Actions as INTEGRATION_ACTIONS } from "./integrationActions";
import { Actions as LEAVE_ACTIONS } from "./leaveActions";
import { Actions as NOTIFICATION_ACTIONS } from "./notificationActions";
import { Actions as PAYPERIOD_ACTIONS } from "./payPeriodActions";
import { Actions as PAYMENT_ACTIONS } from "./paymentActions";
import { Actions as SCHEME_ACTIONS } from "./schemeActions";
const settingsRequest = createRequest({
	urlPath: "/settings",
	// local: true,
});

// types of action
const Types = {
	COMPANY_TAB: "COMPANY_TAB",
	COMPANY_NEW_OPEN_MODAL: "COMPANY_NEW_OPEN_MODAL",
	COMPANY_OPEN_MODAL: "COMPANY_OPEN_MODAL",
	COMPANY_FILE_UPLOADING: "COMPANY_FILE_UPLOADING",
	COMPANY_FILE_UPLOADED: "COMPANY_FILE_UPLOADED",
	COMPANY_LOADED_SETTINGS: "COMPANY_LOADED_SETTINGS",
	COMPANY_UPDATE_FIELD: "COMPANY_UPDATE_FIELD",
	COMPANY_MULTI_OPTION_FIELD: "COMPANY_MULTI_OPTION_FIELD",
	COMPANY_CREATING: "COMPANY_CREATING",
	COMPANY_CREATED: "COMPANY_CREATED",
	COMPANY_GET_BY_ADVISOR: "COMPANY_GET_BY_ADVISOR",
	COMPANY_ADMIN_LIST: "COMPANY_ADMIN_LIST",
	COMPANY_BANK_TRANSFER_MODAL: "COMPANY_BANK_TRANSFER_MODAL",
	COMPANY_BANK_TRANSFER_PERIOD: "COMPANY_BANK_TRANSFER_PERIOD",
	COMPANY_DETAILS_UPDATING: "COMPANY_DETAILS_UPDATING",
	COMPANY_SHOW_BILLING_MODAL: "COMPANY_SHOW_BILLING_MODAL",
	COMPANY_ADVANCED_SETTINGS_MODAL: "COMPANY_ADVANCED_SETTINGS_MODAL",
	COMPANY_HMRCCREDENTIALS_MODAL_STATUS: "COMPANY_HMRCCREDENTIALS_MODAL_STATUS",
	COMPANY_HMRC_PASSWORD_UPDATING: "COMPANY_HMRC_PASSWORD_UPDATING",
	COMPANY_UPDATE_PERIOD_MODAL: "COMPANY_UPDATE_PERIOD_MODAL",
	COMPANY_ARCHIVE_MODAL: "COMPANY_ARCHIVE_MODAL",
	COMPANY_LOADED_JURISDICTIONS: "COMPANY_LOADED_JURISDICTIONS",
	COMPANY_GET_BILLING_EMAILS: "COMPANY_GET_BILLING_EMAILS",
	COMPANY_OPEN_BILLING_EMAIL_MODAL: "COMPANY_OPEN_BILLING_EMAIL_MODAL",
	COMPANY_UPDATE_SETUP_TOGGLE: "COMPANY_UPDATE_SETUP_TOGGLE",
	COMPANY_UPDATE_SETUP_TARGETS: "COMPANY_UPDATE_SETUP_TARGETS",
	COMPANY_UPDATE_SETUP_PROGRESS: "COMPANY_UPDATE_SETUP_PROGRESS",
	COMPANY_LOADING: "COMPANY_LOADING",
	COMPANY_LOADED_ADVISOR: "COMPANY_LOADED_ADVISOR",
};

const companyTab = (tab) => ({
	type: Types.COMPANY_TAB,
	tab,
});

const setNewCompanyModal = (isNewCompanyModalOpen) => ({
	type: Types.COMPANY_NEW_OPEN_MODAL,
	isNewCompanyModalOpen: isNewCompanyModalOpen,
});

const advancedSettingsModal = (toggle, modalType) => ({
	type: Types.COMPANY_ADVANCED_SETTINGS_MODAL,
	toggle,
	modalType,
});

const setBillingModal = (billingModal) => ({
	type: Types.COMPANY_SHOW_BILLING_MODAL,
	billingModal,
});

const setBankTransferModal = (isBankTransferModalOpen) => ({
	type: Types.COMPANY_BANK_TRANSFER_MODAL,
	isBankTransferModalOpen,
});

const setBankTransferPeriod = (period) => ({
	type: Types.COMPANY_BANK_TRANSFER_PERIOD,
	period,
});

const setCompanyModal = (isCompanyModalOpen) => ({
	type: Types.COMPANY_OPEN_MODAL,
	isCompanyModalOpen: isCompanyModalOpen,
});

const setFileUploading = (file) => ({
	type: Types.COMPANY_FILE_UPLOADING,
	file,
});

const setFileUploaded = (file, key) => ({
	type: Types.COMPANY_FILE_UPLOADED,
	file,
	key,
});

const handleLogoUpload = ({ file, org }) => {
	return (dispatch, getState) => {
		const state = getState();

		const path = "/settings/company-settings/upload";

		dispatch(setFileUploading(file.name));

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				name: file.name,
				type: file.type,
				org,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("getImportStatus", data);

				const fileKey = data.key;

				// step 1 upload to AWS
				fetch(data.url, {
					credentials: "include",
					method: "PUT",
					body: file,
					headers: {
						"Accept": "application/json",
						"Content-Type": file.type,
					},
				}).then((data) => {
					dispatch(setFileUploaded(file.name, fileKey));
				});
			});
	};
};

const updateSetting = (field, newValue, newCompany, fieldType, id) => ({
	type: Types.COMPANY_UPDATE_FIELD,
	field,
	newValue,
	newCompany,
	fieldType,
	id,
});

const addMultiOptionField = ({ parent, newCompany, field }) => ({
	type: Types.COMPANY_MULTI_OPTION_FIELD,
	parent,
	newCompany,
	field,
});

const setCompanyLoading = (loading) => ({
	type: Types.COMPANY_LOADING,
	loading,
});

const loadedCompanySettings = (payload, newModal) => ({
	type: Types.COMPANY_LOADED_SETTINGS,
	payload,
	newModal,
});

const loadedCompanyAdvisor = (payload) => ({
	type: Types.COMPANY_LOADED_ADVISOR,
	payload,
});

const setArchiveModal = (show) => ({
	type: Types.COMPANY_ARCHIVE_MODAL,
	show,
});

const getCompanyPromise = (includeLogo) => {
	return settingsRequest({
		path: `/company-settings`,
		query: { includeLogo },
		method: "GET",
	});
};

const getCompanySettings = (includeLogo, switchTo) => {
	return async (dispatch, getState) => {
		dispatch(setCompanyLoading(true));

		await getCompanyPromise(includeLogo)
			.then(({ data: { company, advisor } }) => {
				dispatch(loadedCompanySettings(company));
				if (advisor) dispatch(loadedCompanyAdvisor(advisor));
				if (company.org) {
					dispatch(SCHEME_ACTIONS.getSchemes());
					dispatch(ALLOWANCEACTIONS.allowanceGetList());
					dispatch(EMPLOYEE_ACTIONS.getCola());
					dispatch(INTEGRATION_ACTIONS.integrationGetList());
					dispatch(NOTIFICATION_ACTIONS.getNotifications());
					dispatch(LEAVE_ACTIONS.getLeaveSettings());
					dispatch(PAYPERIOD_ACTIONS.getPayPeriods());
					dispatch(PAYMENT_ACTIONS.getPaymentStats());
					dispatch(WORK_LOCATION_ACTIONS.getWorkLocationSettings());
				}

				if (switchTo) {
					if (company.status === "Setup") switchTo = "/organisation/setup";
					window.history.pushState(null, null, switchTo);
				}
			})
			.catch((error) => {
				console.error(error);
			});
		dispatch(setCompanyLoading());
	};
};

const loadedAdvisorCompanies = (payload) => ({
	type: Types.COMPANY_GET_BY_ADVISOR,
	payload,
});

const getStepFunctionState = ({ arn, name }) => {
	return (dispatch, getState) => {
		const path = `/settings/step-function-state/${arn}`;

		fetch(apiURL + path, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				const finished = data.data.status != "RUNNING";

				if (finished) {
					switch (name) {
						case "AdminMigrateCompany":
							if (data.data.status == "SUCCEEDED") {
								NotificationManager.success("Company migrated successfully!", "Migrating Company");
							} else {
								NotificationManager.error(
									"There was an error migrating this company",
									"Migrating Company",
								);
							}
							break;
					}
				} else {
					setTimeout(() => {
						dispatch(getStepFunctionState({ arn, name }));
					}, 1000);
				}
			});
	};
};

const adminMigrateCompany = () => {
	return (dispatch, getState) => {
		const state = getState();

		const org = state.company?.settings?.org;
		let path = `/settings/company/migrate`;

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				org,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				const arn = data.executionArn;
				NotificationManager.info("Migrating company to staging! - This may take a while", "Migrating Company");

				setTimeout(() => {
					dispatch(
						getStepFunctionState({
							arn,
							name: "AdminMigrateCompany",
						}),
					);
				}, 1000);
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error migrating this company", "Migrating Company");
			});
	};
};

const getAdvisorCompanies = () => {
	return (dispatch, getState) => {
		const path = `/settings/advisor`;
		fetch(apiURL + path, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => dispatch(loadedAdvisorCompanies(data.companies)));
	};
};

const loadedAdminCompanies = (payload) => ({
	type: Types.COMPANY_ADMIN_LIST,
	payload,
});

const getAdminOrganisations = () => {
	return (dispatch, getState) => {
		const path = `/authentication/admin/organisations`;
		fetch(apiURL + path, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => dispatch(loadedAdminCompanies(data)));
	};
};

const loadedJurisdictions = (payload) => ({
	type: Types.COMPANY_LOADED_JURISDICTIONS,
	payload,
});

const getJurisdictions = () => {
	return async (dispatch, getState) => {

		const response = await settingsRequest({
			path: "/jurisdictions",
			method: "GET",
		});
		console.log('response.data.jurisdictions',response.data.jurisdictions)
		dispatch(loadedJurisdictions(response.data.jurisdictions))
		
	};
};

const updatingCompanyDetails = (status) => ({
	type: Types.COMPANY_DETAILS_UPDATING,
	status,
});

const updateCompanyDetails = (body, preventNotification, forNewModal) => {
	return (dispatch, getState) => {
		dispatch(updatingCompanyDetails(true));
		const path = "/settings/company-settings/save";
		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(body),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(updatingCompanyDetails(false));
				if (forNewModal) {
					dispatch(loadedCompanySettings(body, forNewModal));
					if (typeof forNewModal === 'function') forNewModal();
					return;
				}
				// console.log(data)
				dispatch(getCompanySettings(true));
				if (preventNotification) return;
				NotificationManager.success("Company Settings Saved Successfully!", "Saving Company Settings");
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Company Settings", "Saving Company Settings");
			});
	};
};

const updateSetupToggles = (key) => ({
	type: Types.COMPANY_UPDATE_SETUP_TOGGLE,
	key,
});

const updateSetupProgress = (progress) => ({
	type: Types.COMPANY_UPDATE_SETUP_PROGRESS,
	progress,
});

const updateSetupTargets = (key, value) => ({
	type: Types.COMPANY_UPDATE_SETUP_TARGETS,
	key,
	value,
});

const updateSetupPromise = pDebounce((body) => {
	return new Promise(async (resolve, reject) => {
		const response = await settingsRequest({
			path: "/company-settings/setup-steps",
			method: "POST",
			body,
		});
		resolve(response);
	});
}, 1000);

const updateSetupSteps = () => {
	return (dispatch, getState) => {
		const state = getState();
		const body = state.company?.settings?.setup;

		updateSetupPromise(body)
			.then(({ data }) => {
				dispatch(loadedCompanySettings(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Company Settings", "Saving Company Settings");
			});
	};
};

const setHMRCCredentialsModalStatus = (status) => ({
	type: Types.COMPANY_HMRCCREDENTIALS_MODAL_STATUS,
	status,
});

const updatingHMRCPassword = (status) => ({
	type: Types.COMPANY_HMRC_PASSWORD_UPDATING,
	status,
});

const updateHMRCPassword = (password, preventNotification) => {
	return (dispatch, getState) => {
		dispatch(updatingHMRCPassword(true));
		const path = "/settings/company-settings/hmrc/update-password";
		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ password }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(getCompanySettings(true));
				if (preventNotification) return;
				NotificationManager.success("HMRC Password Updated Successfully!", "Update HMRC Password");
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Updating HMRC Password", "Update HMRC Password");
			});

		dispatch(updatingHMRCPassword(false));
		dispatch(setHMRCCredentialsModalStatus(false));
	};
};

const creatingCompany = (payload) => ({
	type: Types.COMPANY_CREATING,
	payload,
});

const createdCompany = (id) => ({
	type: Types.COMPANY_CREATED,
	id,
});

const createCompany = (body, forNewModal) => {
	return (dispatch, getState) => {
		dispatch(updatingCompanyDetails(true));
		dispatch(creatingCompany(body));
		const path = "/settings/company/create";
		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(body),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(updatingCompanyDetails(false));
				if (forNewModal) {
					body.org = data.id;
					dispatch(loadedCompanySettings(body, forNewModal));
					if (typeof forNewModal === 'function') forNewModal();
					return;
				}
				dispatch(createdCompany(data.id));
				dispatch(loadedCompanySettings(body, true));
			});
	};
};

const showUpdatePeriodTypeModal = (id, proposedType) => ({
	type: Types.COMPANY_UPDATE_PERIOD_MODAL,
	id,
	proposedType,
});

const loadedBillingEmails = (payload) => ({
	type: Types.COMPANY_GET_BILLING_EMAILS,
	payload,
});

const getBillingEmails = () => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/billingEmails`, {
			credentials: "include",
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => dispatch(loadedBillingEmails(data)))
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error getting billing emails", "Getting Billing Emails");
			});
	};
};

const openBillingEmailModal = (email, status) => ({
	type: Types.COMPANY_OPEN_BILLING_EMAIL_MODAL,
	email,
	status,
});

const Actions = {
	companyTab,
	addMultiOptionField,
	setNewCompanyModal,
	setCompanyModal,
	handleLogoUpload,
	updateCompanyDetails,
	getCompanySettings,
	getAdvisorCompanies,
	updateSetting,
	createCompany,
	getAdminOrganisations,
	setBankTransferModal,
	setBankTransferPeriod,
	setBillingModal,
	advancedSettingsModal,
	adminMigrateCompany,
	updateHMRCPassword,
	setHMRCCredentialsModalStatus,
	showUpdatePeriodTypeModal,
	setArchiveModal,
	getJurisdictions,
	getBillingEmails,
	openBillingEmailModal,
	updateSetupSteps,
	updateSetupToggles,
	updateSetupTargets,
	updateSetupProgress,
	loadedCompanyAdvisor,
	loadedCompanySettings,
};

export { Actions, Types };
